<template>
	<div class="footer-tabbar">
		<div class="footer-tabbar-placeholder"></div>
		<div class="footer-tabbar-wrap">
			<div
				v-for="(tab, tabIndex) in formattedTabs"
				:key="tab.id"
				class="footer-tabbar-item"
				:class="{
					'footer-tabbar-item--active': tabIndex === activeTab
				}"
				@click="handleTabChange(tab, tabIndex)"
			>
				<m-svg-icon v-if="tab.menuLogoSource === 0" :name="getMenuLogo(tab)" class="footer-tabbar-svg" />
				<van-image v-else :src="tab.menuLogo" fit="cover" class="footer-tabbar-icon" />
				<span>{{ tab.name }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { Image as VanImage } from 'vant';

const props = defineProps({
	// 原始菜单数据列表
	menus: {
		type: Array,
		default: () => []
	},
	// 当前激活的 tab 索引
	activeTab: {
		type: Number,
		default: 0
	}
});

const emit = defineEmits(['change']);

// 格式化 tab 数据
const formattedTabs = computed(() => {
	return props.menus.map(data => {
		const item = {
			id: data.id,
			name: data.name,
			menuLogo: data.menuLogo,
			menuLogoSource: data.menuLogoSource
		};
		return item;
	});
});

const handleTabChange = (tab, tabIndex) => {
	if (props.activeTab === tabIndex) return;
	emit('change', tab, tabIndex);
};

const getMenuLogo = menu => {
	const svgReg = new RegExp(/\/([^/.]+)\.svg$/);
	const match = menu?.menuLogo?.match(svgReg);
	if (match) {
		const result = match[1];
		// `assets/icons/tab_xxx.svg`
		return `tab_${result}`;
	}
	return '';
};
</script>

<style lang="less" scoped>
.footer-tabbar {
	.footer-tabbar-placeholder,
	.footer-tabbar-wrap {
		box-sizing: content-box;
		height: 0.52rem;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}
	.footer-tabbar-wrap {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: #ffffff;
		box-shadow: 0 -0.025rem 0.065rem 0 rgba(0, 0, 0, 0.02);
		display: flex;
	}
	.footer-tabbar-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #333;
		position: relative;

		span {
			font-family: 'PingFang SC';
			font-size: 0.1rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.14rem;
		}
		&--active {
			color: var(--ir-theme-color);
		}
	}

	.footer-tabbar-icon {
		width: 0.24rem;
		height: 0.24rem;

		/deep/.van-image__error-icon {
			font-size: 0.24rem;
		}
	}
	.footer-tabbar-svg {
		font-size: 0.24rem;
	}
}
</style>
